import Swiper, {
  Navigation,
  Pagination,
  Thumbs,
  Autoplay,
  EffectFade,
} from "swiper";

$(function () {
  const relatedInsight = {
    init() {
      relatedInsight.create();

      relatedInsight.scrolledPosition();

      $(window).on("scroll", function () {
        relatedInsight.scrolledPosition();
      });

      $(window).on("resize", function () {
        relatedInsight.scrolledPosition();
      });
    },
    create() {
      const theContent = $(".the-content");
      if (theContent.length) {
        const ele = $("[data-related-insight]");
        const blDetails = $(".the-content").find(
          ".bl-details, section.panel"
        );
        if (ele.length == 0) return;

        const lastElementOfContent = theContent.children().last();
        let eleToAppendRelated;
        let eleToAppendPosts;

        if (blDetails.length === 0 || !(lastElementOfContent.hasClass("bl-details") || lastElementOfContent.hasClass("panel"))) {
          eleToAppendRelated = theContent;
          eleToAppendPosts = theContent;
        } else {
          if (blDetails.length >= 4) {
            eleToAppendRelated = blDetails.eq(3);
          } else if (blDetails.length >= 2) {
            eleToAppendRelated = blDetails.eq(1);
          } else {
            eleToAppendRelated = blDetails.eq(0);
          }

          if (blDetails.length >= 2) {
            eleToAppendPosts = blDetails.eq(1);
          } else {
            eleToAppendPosts = blDetails.eq(0);
          }
        }

        // 3: Recommend Services
        if (
          eleToAppendRelated.length &&
          ele.find(".group--related-service").html()
        ) {
          eleToAppendRelated.after(`<div class="bl-details spacing-right d-mobile">
            <div class="related-insight links mobile">
              ${ele.find(".group--related-service").html() || ""}
            </div>
          </div>`);
        }

        if (eleToAppendPosts.length) {
          // 2: Related Insight
          let htmlTags = "";
          const eleTags = ele.find(".tags li");
          if (eleTags.length) {
            htmlTags = `<ul class="tags">${ele.find(".tags").html()}</ul>`;
          }

          let htmlPosts = "";
          const elePosts = ele.find(".list .item");
          if (elePosts.length) {
            elePosts.each(function () {
              const self = $(this);
              htmlPosts += `<div class="swiper-slide">
                <div class="item">
                  ${self.html()}
                </div>
              </div>`;
            });
          }

          if (htmlPosts) {
            eleToAppendPosts.after(`<div class="bl-details spacing-right d-mobile" style="overflow: hidden">
              <div class="related-insight mobile">
                <p class="title">${ele
                  .find(".group:not(.group--document-library)")
                  .eq(0)
                  .find(".title")
                  .text()}</p>
  
                <div id="ri" class="swiper">
                  <div class="swiper-wrapper list">
                    ${htmlPosts}
                  </div>
                  <div class="swiper-pagination"></div>
              </div>
  
              ${htmlTags}
            </div>`);
          }

          setTimeout(() => {
            const slider = new Swiper(`#ri`, {
              modules: [Navigation, Pagination],
              slidesPerView: "auto",
              pagination: {
                el: ".swiper-pagination",
              },
              on: {
                init: function () {
                  $(window).trigger("resize");
                },
              },
            });
          }, 150);

          // 1: Document Library
          let htmlDocsLibrary = "";
          const eleDocsLibrary = ele.find(".group--document-library");
          if (eleDocsLibrary.length) {
            htmlDocsLibrary = eleDocsLibrary.html();
          }

          if (htmlDocsLibrary) {
            eleToAppendPosts.after(`<div class="bl-details spacing-right d-mobile">
              <div class="related-insight related-insight--document-library mobile">  
                ${htmlDocsLibrary}
              </div>
            </div>`);
          }
        }
      }
    },
    scrolledPosition() {
      if (!$("[data-point-to-sticky]").length) return;
      const ele = $("[data-related-insight]");
      const eleH = ele.height();
      const pContent = $(".p-detail.content").eq(1);

      const st = $(window).scrollTop();
      if (
        st >=
        $("[data-point-to-sticky]").first().offset().top - $("header").height()
      ) {
        const bDistance = pContent.offset().top + pContent.height();
        if (st > bDistance - eleH - $("header").height()) {
          // ele.css({
          //   position: "absolute",
          //   top: bDistance - eleH - 40,
          // });
        } else {
          // ele.css({
          //   position: "fixed",
          //   top: $("header").height(),
          // });
        }
      } else {
        ele.css({
          position: "absolute",
          top: $("[data-point-to-sticky]").first().offset().top,
        });
      }
    },
  };

  relatedInsight.init();
});
